import React from "react";

const AdnLogoCollapsed = ({ width = 22, height = 20, className = "" }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4176 17.9794L11.2421 8.10097L13.2569 4.2554C13.3037 4.16596 13.3455 4.0752 13.3822 3.98345L19.7894 16.2129C20.2772 17.144 19.9178 18.2942 18.9867 18.782C18.0557 19.2699 16.9054 18.9105 16.4176 17.9794ZM15.5318 18.4435L10.6776 9.17837L5.82514 18.4404C5.08102 19.8607 3.32641 20.4088 1.90611 19.6647C0.485809 18.9206 -0.0623453 17.166 0.681774 15.7457L7.96179 1.85028C7.96245 1.84859 7.96311 1.84689 7.96377 1.8452L7.96665 1.83971C8.21313 1.21324 8.67743 0.669109 9.32056 0.332164C9.93929 0.00800115 10.6215 -0.0709187 11.2559 0.0606715C11.5203 0.113783 11.7816 0.204909 12.0325 0.336367C12.6654 0.667918 13.1251 1.20008 13.3744 1.81389L20.6752 15.7488C21.4193 17.1691 20.8711 18.9237 19.4508 19.6678C18.0305 20.412 16.2759 19.8638 15.5318 18.4435ZM10.1129 8.10154L4.93935 17.9763C4.45153 18.9074 3.30128 19.2667 2.37019 18.7789C1.4391 18.2911 1.07975 17.1409 1.56757 16.2098L7.97249 3.98467C8.00866 4.07453 8.04965 4.16343 8.09556 4.25105L10.1129 8.10154Z"
        fill="#0A2038"
      />
    </svg>
  );
};

export default AdnLogoCollapsed;
